import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const IndustryCard = ({ industry }) => {
  return (
    <div className="group bg-card rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-border h-full flex flex-col">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={industry?.image}
          alt={industry?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/40 to-transparent"></div>
        <div className="absolute bottom-4 left-4 right-4">
          <div className="flex items-center space-x-2 mb-2">
            <div className="w-10 h-10 bg-primary/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
              <Icon name={industry?.icon} size={20} className="text-primary" />
            </div>
            <h3 className="text-xl md:text-2xl font-bold font-headline text-foreground">{industry?.name}</h3>
          </div>
        </div>
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <p className="text-sm md:text-base text-muted-foreground font-body mb-4 line-clamp-3 flex-1">
          {industry?.description}
        </p>
        
        <div className="space-y-3 mb-6">
          <div className="flex items-start space-x-3">
            <Icon name="CheckCircle2" size={18} className="text-success mt-0.5 flex-shrink-0" />
            <span className="text-sm text-foreground font-body">{industry?.expertise1}</span>
          </div>
          <div className="flex items-start space-x-3">
            <Icon name="CheckCircle2" size={18} className="text-success mt-0.5 flex-shrink-0" />
            <span className="text-sm text-foreground font-body">{industry?.expertise2}</span>
          </div>
          <div className="flex items-start space-x-3">
            <Icon name="CheckCircle2" size={18} className="text-success mt-0.5 flex-shrink-0" />
            <span className="text-sm text-foreground font-body">{industry?.expertise3}</span>
          </div>
        </div>
        
        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center space-x-2">
            <Icon name="Briefcase" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground font-body">{industry?.projectCount} Projects</span>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors duration-200 text-sm font-medium font-body"
          >
            <span>Learn More</span>
            <Icon name="ArrowRight" size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default IndustryCard;